var _linearGradient, _linearGradient2, _filter, _mask, _clipPath, _mask2, _clipPath2, _mask3, _clipPath3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _path15, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-2 -2 132 132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 98,
    x2: 108,
    y1: 112,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#16529c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#236ac0"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 58,
    x2: 14,
    y1: 120,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2166bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89eda9"
  }))), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "C",
    width: "100%",
    height: "100%",
    x: "0%",
    y: "0%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "D"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#C)"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.5,
    d: "M0 0h128v128H0z"
  })))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h192v152H0z"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "F"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#C)"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.5,
    d: "M0 0h128v128H0z"
  })))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "G"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h192v152H0z"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "H"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#C)"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.5,
    d: "M0 0h128v128H0z"
  })))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h192v152H0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M64 5a60 60 0 110 120A60 60 0 0164 5zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M64 5a60 60 0 000 120zm0 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#40a1c8",
    d: "M124 63A60 60 0 114 63a60 60 0 01120 0zm0 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#49bbb0",
    d: "M28 64a96 96 0 007.8 38.3 37 37 0 00-9.8 7.1A60 60 0 014 64zm0 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#378bde",
    d: "M64 96v27c-4.5 0-9-.5-13.4-1.5a46.7 46.7 0 01-14.8-19.3A63 63 0 0164 96zm0 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#266ec6",
    d: "M100 64a96 96 0 01-7.8 38.3 37 37 0 019.8 7.1A60 60 0 00124 64zm0 0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#378bde",
    d: "M64 64v59c4.5 0 9-.5 13.4-1.5C90.8 112 99.8 89.4 100 64zm0 0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#266ec6",
    d: "M64 96v27c4.5 0 9-.5 13.4-1.5 5.8-4 10.9-10.7 14.8-19.3A63 63 0 0064 96zm0 0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1e62b5",
    d: "M92.2 102.3c-4 8.5-9 15.1-14.8 19.2a60 60 0 0024.6-12 35 35 0 00-9.8-7.2zm0 0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#53d795",
    d: "M64 3A60 60 0 004 64h60zm0 0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#72e99a",
    d: "M50.6 4.5a60 60 0 00-24.6 12 35 35 0 009.8 7.2c4-8.5 9-15.1 14.8-19.2zm0 0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#49bbb0",
    d: "M64 3c-4.5 0-9 .5-13.4 1.5C37 14.1 28 37.2 28 63v1h36zm0 0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#53d795",
    d: "M64 3c-4.5 0-9 .5-13.4 1.5a46.8 46.8 0 00-14.8 19.3A63 63 0 0064 30zm0 0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#378bde",
    d: "M64 3a60 60 0 0160 61H64zm0 0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#40a1c8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.4 4.5a60 60 0 0124.6 12 35 35 0 01-9.8 7.2c-4-8.5-9-15.1-14.8-19.2zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 3c4.5 0 9 .5 13.4 1.5C91 14.1 100 37.2 100 63v1H64zm0 0"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#49bbb0",
    d: "M64 3c4.5 0 9 .5 13.4 1.5 5.8 4 10.9 10.7 14.8 19.2-8 4-18 6.3-28.2 6.3zm0 0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8 -16)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#E)",
    mask: "url(#D)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2e3436",
    d: "M169.5 24v1h13v-1zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#G)",
    mask: "url(#F)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2e3436",
    d: "M169.5 21v1h13v-1zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#I)",
    mask: "url(#H)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2e3436",
    d: "M169.5 27v1h13v-1zm0 0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.04ab772d4fba10561e33e10c679e671f.svg";
export { ForwardRef as ReactComponent };